const handleErrors = function(error){
  if(error.response) {
    if(error.response.status == 500){
      return "Internal Server Error. The server may be in the middle of a data refresh, please try again in five minutes"
    }else{
      return "An error has occured. Please check your data and try again."
    }
  }else{
    return "Network error. Please try again in five minutes."
  }
}

export default {
  handleErrors
}
